'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../../../node_modules/classnames/index.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var AccordionGroupContext = React.createContext({});
var useAccordionGroupContext = function () { return React.useContext(AccordionGroupContext); };
var AccordionGroup = function (props) {
    var _a = React.useState(), activeId = _a[0], setActiveId = _a[1];
    var id = 0;
    var getUniqueId = function () {
        id = id + 1;
        return id.toString();
    };
    return (React__default['default'].createElement(AccordionGroupContext.Provider, { value: {
            activeId: activeId,
            setActiveId: setActiveId,
            getUniqueId: getUniqueId,
        } },
        React__default['default'].createElement("div", { className: "accordion-group " + (index['default'] || '') }, props.children)));
};

exports.AccordionGroup = AccordionGroup;
exports.useAccordionGroupContext = useAccordionGroupContext;
//# sourceMappingURL=AccordionGroup.js.map
